import React from 'react'
import Header from './Header'

const Terms = () => (<div>
  <section className="hero is-blue-gem-2">
    <Header/>
    <div className="hero-body">
      <div className="container has-text-centered">
        <h1 className="title">
          Park Park Go Terms of Service
        </h1>
      </div>
    </div>
  </section>
</div>)

export default Terms



// WEBPACK FOOTER //
// ./src/components/Terms.js